import { useIonActionSheet } from '@ionic/react';
import { StyledActionSheet } from './ActionSheet.styles';
import { AllieActionSheetProps } from './ActionSheet.types';

export const AllieActionSheet = ({ trigger, triggerButton, ...props }: AllieActionSheetProps) => {
  return (
    <div className="allie-action-sheet">
      {triggerButton({ trigger })}
      <StyledActionSheet {...props} />
    </div>
  );
};


export const useAllieActionSheet = useIonActionSheet;
